import { render } from "./InternetExpiring.vue?vue&type=template&id=0b2d5ba1"
import script from "./InternetExpiring.vue?vue&type=script&lang=js"
export * from "./InternetExpiring.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0b2d5ba1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b2d5ba1', script)) {
    api.reload('0b2d5ba1', script)
  }
  
  module.hot.accept("./InternetExpiring.vue?vue&type=template&id=0b2d5ba1", () => {
    api.rerender('0b2d5ba1', render)
  })

}

script.__file = "src/views/services/modules/internet/pills/InternetExpiring.vue"

export default script